export default __webpack_public_path__ + "static/media/s4img8.60cf6045.webp";